import React, { useEffect, useState } from 'react'
import Card from '../../../../Base/Components/Card/Card'
import { Chart } from 'primereact/chart';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatNumberDecimal } from '../../../../Base/Services/FormatTemplate';
import { Dropdown } from 'primereact/dropdown';


const CardPregunta = ({ item, n }) => {

    const [chart, setChart] = useState(null);

    const [tipoGrafico, setTipoGrafico] = useState('bar');

    const opciones = [
        {
            id: 1,
            name: 'Totalmente en desacuerdo',
            value: 1
        },
        {
            id: 2,
            name: 'En desacuerdo',
            value: 2
        },
        // {
        //     id: 3,
        //     name: 'Ni de acuerdo ni en desacuerdo',
        //     value: 3
        // },
        {
            id: 4,
            name: 'De acuerdo',
            value: 4
        },
        {
            id: 5,
            name: 'Totalmente de acuerdo',
            value: 5
        }
    ]

    const tipoGrafio = [
        {
            id: 1,
            name: 'Barras',
            value: 'bar'
        },
        {
            id: 2,
            name: 'Lineas',
            value: 'line'
        },
        {
            id: 3,
            name: 'Pie',
            value: 'pie'
        },
    ]

    // console.log(item);

    let data = [];

    const createChart = () => {
        if (item.IdTipoPregunta === 1) {

            const respuestasCountValues = opciones.map((opcion) => {
                return item.Respuestas.filter((respuesta) => respuesta.ValueInt === opcion.value).length
            })
            data = respuestasCountValues;
            const chartCuenta = {
                data: {
                    labels:  opciones.map((opcion) => opcion.name),
                    datasets:
                        [
                            {
                                label: '',
                                backgroundColor: tipoGrafico === 'line' ? '#D9048E' : ['#D9048E', '#0378A6', '#A432A6', '#049DBF', '#D973B5', '#EF5350', '#AB47BC'],
                                data: respuestasCountValues,
                                pointStyle: 'circle',
                                borderColor: '#D9048E',
                            },
                        ]
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    interaction: {
                        mode: 'index',
                        intersect: false,
                    },
                    plugins: {
                        datalabels: {
                            color: '#FFF',
                            // anchor: 'top',
                            // align: 'top',
                            // offset: 10,
                            // arrowWidth: 10,
                            // arrowHeight: 10,

                            formatter: function (value, context) {
                                return value  //+ ' (' + formatNumberDecimal(value / d?.Operativo?.MontoL * 100) + '%)';
                            },
                            display: function (context) {
                                switch (tipoGrafico) {
                                    case 'pie':
                                        return context.dataset.data[context.dataIndex] > 2 
                                        break;
                                    case 'bar':
                                        return context.dataset.data[context.dataIndex] > 1
                                        break;

                                    default:
                                    return context.dataset.data[context.dataIndex] > 0 
                                        break;
                                }
                            },
                            font: {
                                weight: 'bold',
                                size: 10,
                            },
                            // backgroundColor: (context) => {
                            //     console.log(tipoGrafico.value === 'line');
                            //     if(tipoGrafico === 'line'){
                            //         return '#D9048E';
                            //     }
                            // },
                        },
                        // title: {
                        //     text: "",
                        //     display: true,
                        //     fontSize: 24,
                        // },
                        legend: {
                            display: tipoGrafico === 'pie' ? true : false,
                            position: 'right',
                            align: 'start',
                            textAlign: 'left',
                            labels: {
                                usePointStyle: true,
                            }
                        },
                        scales: {
                            x: {
                                barPercentage: 0.1,
                            }
                        }
                    },
                }
            }
            setChart(<Chart height={300} width={1000} type={tipoGrafico} data={chartCuenta.data} options={chartCuenta.options} plugins={[ChartDataLabels]} />);
        }
    }

    useEffect(() => {
        if (item) {
            createChart();
        }
    }, [item, tipoGrafico])

    return (
        <div className='my-3' key={n}>
            <Card
                // titulo={<div>
                //     <div className='fw-bold'>{item.Pregunta}
                //     </div>
                // </div>}
                style={{ background: '#FFF' }}
                contenido={
                    <div className='p-3 d-flex' style={{ justifyContent: 'center', flexDirection: 'column' }}>
                        <div className='d-flex' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                            <h5 className='fw-bold'>{n + 1} - {item.Pregunta}</h5>
                            <Dropdown value={tipoGrafico} options={tipoGrafio} onChange={(e) => setTipoGrafico(e.value)} optionLabel="name" placeholder="Seleccione un tipo de grafico" />
                        </div>
                        {chart}
                    </div>
                }
            />
        </div>
    )
}
export default CardPregunta